<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">Performance Report</h1>
        </div>
        <div class="row row-cards">
            <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='2' || myrole=='3'">
                <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                        <div class="d-flex align-items-center">
                            <div class="subheader text-primary">Call Attempts <i  *ngIf="ctoc_performance_loading" class="fas fa-spin fa-spinner"></i>
                                <span *ngIf="preprt_username">&nbsp;({{preprt_username}})</span>
                            </div>
                        </div>
                        <div class="mb-1 mt-2 text-left font-weight500">Target : <span class="text-success">150</span></div>
                        <div class="mb-1 text-left font-weight500"> Today's Call Attempts: <span class="text-success">{{today_call_attempts}}</span></div>
                    </div>
                </div>
            </div>
            <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='2' || myrole=='3'">
                <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                        <div class="d-flex align-items-center">
                            <div class="subheader text-primary">Call Connected <i  *ngIf="ctoc_performance_loading" class="fas fa-spin fa-spinner"></i>
                                <span *ngIf="preprt_username">&nbsp;({{preprt_username}})</span>
                            </div>
                        </div>
                        <div class="mb-1 mt-2 text-left font-weight500">Target : <span class="text-success">50</span></div>
                        <div class="mb-1 text-left font-weight500"> Today's Call Connected: <span class="text-success">{{today_call_connected}}</span></div>
                    </div>
                </div>
            </div>
            <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='2' || myrole=='3'">
                <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                        <div class="d-flex align-items-center">
                            <div class="subheader text-primary">Talk Time <i  *ngIf="ctoc_performance_loading" class="fas fa-spin fa-spinner"></i>
                                <span *ngIf="preprt_username">&nbsp;({{preprt_username}})</span>
                            </div>
                        </div>
                        <div class="mb-1 mt-2 text-left font-weight500">Target : <span class="text-success">180 Min</span></div>
                        <div class="mb-1 text-left font-weight500"> Today's Talk Time: <span class="text-success">{{today_talk_time}}</span></div>
                    </div>
                </div>
            </div>

            <div class="col-6 col-sm-4 col-lg-3" *ngIf="myrole=='2' || myrole=='3'">
                <div class="card flex_class">
                    <div class="card-body p-3 text-center">
                        <div class="d-flex align-items-center">
                            <div class="subheader text-primary">Incentive<i  *ngIf="ctoc_performance_loading" class="fas fa-spin fa-spinner"></i>
                                <span *ngIf="preprt_username">&nbsp;({{preprt_username}})</span>
                            </div>
                        </div>
                        <div class="mb-1 mt-2 text-left font-weight500">Cash IPD  : <span class="text-success">{{cashIpdCount}} ipds * 100 = ({{cashIpdCount * 100}})</span></div>
                        <!-- <div class="mb-1 text-left font-weight500"> Health Plan: <span class="text-success">{{today_talk_time}}</span></div> -->
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
